import { IPayment } from "../../services/BillingService";
import { CommonFactoryInterface } from "../common-factory-type";
import { UpdatePaymentStatusDto } from "./factory-dtos";

/** Label change = only the label (QA batch 12, see the invoice factory). */
class UpdatePaymentStatusFactory
  implements
    CommonFactoryInterface<
      {
        payment: Partial<IPayment>;
        status: string | null;
      },
      UpdatePaymentStatusDto
    >
{
  createModelFromDto = (dto: {
    payment: Partial<IPayment>;
    status: string | null;
  }): UpdatePaymentStatusDto => ({
    id: dto?.payment?.id || "",
    labelId: dto?.status || null,
  });
}

export const updatePaymentStatusFactory = new UpdatePaymentStatusFactory();
